import type { IChangelogEntry } from "@/sanity/pages/PageChangelogTemplate";

export type ChangelogSort = "newest" | "oldest";

export interface ChangelogRelease {
  date: string;
  entries: IChangelogEntry[];
}

export const ALL_CATEGORIES = "__all__";

const DATE_FORMAT = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "2-digit",
  year: "numeric",
  timeZone: "UTC",
});

// Sanity `date` fields are plain YYYY-MM-DD strings; format in UTC so the
// day never shifts with the viewer's timezone.
export function formatReleaseDate(date: string) {
  const parsed = new Date(`${date}T00:00:00Z`);
  return Number.isNaN(parsed.getTime()) ? date : DATE_FORMAT.format(parsed);
}

export function entryFilterKey(entry: IChangelogEntry) {
  return entry.filterCategory?.trim() || entry.category;
}

export function groupReleases(entries: IChangelogEntry[]): ChangelogRelease[] {
  const byDate = new Map<string, IChangelogEntry[]>();
  for (const entry of entries) {
    if (!entry?.date) continue;
    const list = byDate.get(entry.date) ?? [];
    list.push(entry);
    byDate.set(entry.date, list);
  }
  return Array.from(byDate, ([date, list]) => ({ date, entries: list }));
}

export function sortReleases(releases: ChangelogRelease[], sort: ChangelogSort) {
  const sorted = [...releases].sort((a, b) => b.date.localeCompare(a.date));
  return sort === "newest" ? sorted : sorted.reverse();
}

export function listCategories(entries: IChangelogEntry[]) {
  return Array.from(new Set(entries.map(entryFilterKey).filter(Boolean)));
}
